import { render, staticRenderFns } from "./dataReportCenter.vue?vue&type=template&id=8c109174&scoped=true"
import script from "./dataReportCenter.vue?vue&type=script&lang=js"
export * from "./dataReportCenter.vue?vue&type=script&lang=js"
import style0 from "./dataReportCenter.vue?vue&type=style&index=0&id=8c109174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c109174",
  null
  
)

export default component.exports